export default "__VITE_ASSET__CG9AioJD__"